import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MacUserService } from '../../../services/user/mac-user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiErrorResponse, ApiResponse, ApiServiceInterface } from '@hutsix/ngxh6';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();

    public signin: any = {
        email: null,
        password: null,
    };

    public error?: string;
    public loading = false;

    constructor(
        @Inject('ApiService') private api: ApiServiceInterface,
        @Inject('UserService') private userService: MacUserService,
        private cdRef: ChangeDetectorRef,
    ) {}

    public doSignin(): void {
        this.loading = true;
        this.api.post({ url: '/api/user/login_check', data: this.signin, skipAuth: true }).subscribe(
            (res: ApiResponse<any>) => {
                this.error = null;
                this.userService
                    .loginUser(res.data)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe(() => {
                        this.userService.reloadRoute('/');
                    });
            },
            (err: ApiErrorResponse<any>) => {
                this.loading = false;
                this.error = err.error?.error ? `${err.error.error.code} ${err.error.error.message}` : err.error?.message;
                this.cdRef.detectChanges();
            },
        );
    }

    ngOnInit(): void {
        this.userService.watch.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            if (user.loggedIn) this.userService.reloadRoute('/');
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
